import { makeConstantFactory } from 'utils/constantsHelper'

const makeConstant = makeConstantFactory('classification')

// Org level settings
export const FETCH_ASSISTANT_ORG_SETTINGS = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS')
export const FETCH_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_PENDING')
export const FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS')
export const FETCH_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_FAILED')

export const CREATE_ASSISTANT_ORG_SETTINGS = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS')
export const CREATE_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_PENDING')
export const CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS')
export const CREATE_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_FAILED')

export const PATCH_ASSISTANT_ORG_SETTINGS = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS')
export const PATCH_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_PENDING')
export const PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS')
export const PATCH_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_FAILED')

// Agent level settings
export const FETCH_ASSISTANT_AGENT_SETTINGS = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS')
export const FETCH_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_PENDING')
export const FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS')
export const FETCH_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_FAILED')

export const CREATE_ASSISTANT_AGENT_SETTINGS = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS')
export const CREATE_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_PENDING')
export const CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS')
export const CREATE_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_FAILED')

export const PATCH_ASSISTANT_AGENT_SETTINGS = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS')
export const PATCH_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_PENDING')
export const PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS')
export const PATCH_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_FAILED')

// Salesforce settings
export const FETCH_SALESFORCE_SETTINGS = makeConstant('FETCH_SALESFORCE_SETTINGS')
export const FETCH_SALESFORCE_SETTINGS_PENDING = makeConstant('FETCH_SALESFORCE_SETTINGS_PENDING')
export const FETCH_SALESFORCE_SETTINGS_SUCCESS = makeConstant('FETCH_SALESFORCE_SETTINGS_SUCCESS')
export const FETCH_SALESFORCE_SETTINGS_FAILED = makeConstant('FETCH_SALESFORCE_SETTINGS_FAILED')

// Personalization tags
export const FETCH_PERSONALIZATION_TAGS = makeConstant('FETCH_PERSONALIZATION_TAGS')
export const FETCH_PERSONALIZATION_TAGS_PENDING = makeConstant('FETCH_PERSONALIZATION_TAGS_PENDING')
export const FETCH_PERSONALIZATION_TAGS_SUCCESS = makeConstant('FETCH_PERSONALIZATION_TAGS_SUCCESS')
export const FETCH_PERSONALIZATION_TAGS_FAILED = makeConstant('FETCH_PERSONALIZATION_TAGS_FAILED')

// Editing state constants
export const SET_INITIAL_ORG_EDIT_STATE = makeConstant('SET_INTITIAL_ORG_EDIT_STATE')

export const SET_INITIAL = makeConstant('SET_INITIAL')
export const ON_UPDATE = makeConstant('ON_UPDATE')
export const ON_WARM_LEAD_UPDATE = makeConstant('ON_WARM_LEAD_UPDATE')
export const ON_WARM_LEAD_UPDATE_TEMPLATE = makeConstant('ON_WARM_LEAD_UPDATE_TEMPLATE')
export const ON_CANCEL = makeConstant('ON_CANCEL')


export const SEND_TEST_EMAIL = makeConstant('SEND_TEST_EMAIL')
export const SEND_TEST_EMAIL_PENDING = makeConstant('SEND_TEST_EMAIL_PENDING')
export const SEND_TEST_EMAIL_SUCCESS = makeConstant('SEND_TEST_EMAIL_SUCCESS')
export const SEND_TEST_EMAIL_FAILED = makeConstant('SEND_TEST_EMAIL_FAILED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/assistantSettings/constants.js